package com.shreyasjoshi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.components.*

@Page
@Composable
fun HomePage() {
    var isDarkMode by remember { mutableStateOf(true) }
    var isResumeModalOpen by remember { mutableStateOf(false) }

    Div(
        attrs = {
            classNames(
                "min-h-screen", "flex", "flex-col", "transition-colors", "duration-200",
                if (isDarkMode) "bg-[#050505] text-white" else "bg-white text-slate-900"
            )
        }
    ) {
        // Sticky Navigation Bar
        Navbar(
            isDarkMode = isDarkMode,
            onToggleTheme = { isDarkMode = !isDarkMode },
            onOpenResumeModal = { isResumeModalOpen = true }
        )

        // Main Portfolio Sections
        Main(attrs = { classNames("flex-1", "w-full") }) {
            HeroSection(
                isDarkMode = isDarkMode,
                onOpenResumeModal = { isResumeModalOpen = true }
            )
            AboutSection(isDarkMode = isDarkMode)
            ExperienceSection(isDarkMode = isDarkMode)
            ProjectsSection(isDarkMode = isDarkMode)
            SkillsSection(isDarkMode = isDarkMode)
            KnowledgeBaseSection(isDarkMode = isDarkMode)
            ContactSection(isDarkMode = isDarkMode)
        }

        // Global Footer
        Footer(
            isDarkMode = isDarkMode,
            onOpenResumeModal = { isResumeModalOpen = true }
        )

        // Interactive Resume Document Modal
        ResumeModal(
            isOpen = isResumeModalOpen,
            isDarkMode = isDarkMode,
            onClose = { isResumeModalOpen = false }
        )
    }
}



